Vue.component("profileselect", {
  props: {
    search: {
      type: Object
    },
    updates: {
      type: Number
    },
    isLoadingTable: {
      type: Boolean
    },
    dataset: {
      type: String
    },
    datafieldsdata: {
      type: Object
    },
    datafieldids: {
      type: String
    },
    preset: { default: false, required: false },
    fielddata: {},
    districtdata: {}
  },
  data() {
    return {
      minMax: {},
      isLoaded: false,
      isStarted: false,
      selectedData: {},
      searchData: {},
      activeDistrict: false,
      matchedDistricts: {},
      isUpdating: false,
      pendingChange: true,
      peerSlidersLoaded: false,
      maxRecommend: 15,
      firstPeerSearch: false,
      firstPeerSearchNumber: false,
      staffingData: {}
    };
  },
  computed: {
    datafields() {
      return JSON.parse(this.datafieldids);
    },
    backgroundfields() {
      return JSON.parse(this.backgroundids);
    },
    noPeerDistricts() {
      if (this.isUpdating) {
        return "Fetching peers...";
      }
      if (Object.entries(this.matchedDistricts).length > 0) {
        return false;
      }

      return "No Peers Selected Yet";
    },
    peerDistricts() {
      if (this.noPeerDistricts) {
        return false;
      }
      let peers = {};
      for (let i = 0; i < this.matchedDistricts.shared.length; i++) {
        if (
          this.districtdata[this.matchedDistricts.shared[i]] &&
          this.matchedDistricts.shared[i] != this.activeDistrict
        ) {
          peers[this.matchedDistricts.shared[i]] =
            this.districtdata[this.matchedDistricts.shared[i]];
        }
      }
      if (Object.entries(peers).length === 0) {
        return false;
      }
      return peers;
    },
    peerDistrictNumber() {
      if (!this.peerDistricts) {
        return 0;
      }
      return formatSlideData(Object.entries(this.peerDistricts).length, "Number");
    },
    peerMessage() {
      if (this.peerDistrictNumber > this.maxRecommend) {
        return "We recommend no more than " + this.maxRecommend + " peers for the best experience";
      }
      return false;
    },
    updateButtonText() {
      if (this.isLoading) {
        return "Loading...";
      }
      if (this.pendingChange) {
        return "Update Peers";
      }
      return "Peers Selected";
    }
  },
  watch: {
    peerDistricts(val) {
      if (val) {
        let arr = [];
        arr.push(this.districtdata[this.activeDistrict]);
        for (d in this.peerDistricts) {
          arr.push(this.peerDistricts[d]);
        }
        let filtervalues = {
          field: "nces_id",
          selected: arr,
          key: "nces_id"
        };
        this.$emit("updatesearch", "filters", filtervalues);
      }
    }
  },
  async created() {
    // get max & min for each field
    // one query
    let $this = this;

    let data_field_ids = JSON.stringify(this.datafields);
    let data = {};
    let stateinfo = slideGetStorage("slide_get_minmax_" + data_field_ids);
    if (stateinfo) {
      data.data = stateinfo;
    } else {
      let obj = new FormData();
      let params = '{"fields":' + data_field_ids + "}";
      obj.append("action", "slide_get_minmax");
      obj.append("params", params);
      data = await axios.post(axios_ajax.ajaxurl, obj);
      slideSetStorage("slide_get_minmax_" + data_field_ids, data.data);
    }

    this.minMax = data.data;
  },
  mounted() {
    let $this = this;
    this.addListeners();
    setTimeout(function () {
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has("nces_id")) {
        let p = {};
        p.nces_id = urlParams.get("nces_id");
        $this.getprofiledistrictdata(p);
      }
    }, 0);
  },
  methods: {
    addListeners() {
      let $this = this;
      bus.$on("autocompleteisloaded", function (autocompleteid) {
        let input = document.querySelector("#search_districts_profile input");
        if (input && input.id && input.id == "autocomplete-" + autocompleteid) {
          $this.$nextTick(function () {
            document.getElementById(input.id).focus();
          });
        }
      });

      bus.$on("addPeer", function (nces) {
        $this.matchedDistricts.shared.push(nces);
      });

      bus.$on("getsavedprofiledistrictdata", function (nces) {
        $this.getprofiledistrictdata({ nces_id: nces });
      });
    },
    async getprofiledistrictdata(p) {
      let nces_id = p.nces_id;
      this.activeDistrict = nces_id;
      this.$refs.slide_profile_districts.classList.add("sliding");
      this.$refs.profile_demographics_wrapper.classList.add("sliding");
      this.$refs.slide_profile_select.classList.add("started");

      if (this.preset == "profile") {
        this.isStarted = true;
        let obj = new FormData();
        obj.append("action", "slide_get_search_data");
        let data_field_ids = JSON.stringify(this.datafields);
        let params =
          '{"filters":{"nces_id":["' +
          nces_id +
          '"],"data_field_id":' +
          data_field_ids +
          '},"fields":{}}';
        obj.append("params", params);
        let data = await axios.post(axios_ajax.ajaxurl, obj);

        let selectedData = {};
        for (const d in data.data) {
          let thisd = data.data[d];
          selectedData[thisd.data_field_id] = thisd.data_value;
        }

        let action = "slide_get_agency_info";
        obj = new FormData();
        obj.append("action", action);
        obj.append("nces_id", nces_id);

        let perfObj = {
          method: "post",
          url: axios_ajax.ajaxurl,
          obj: obj,
          action: action
        };
        data = await slidePerf(perfObj);
        this.peerSlidersLoaded = true;
        //data = await axios.post(axios_ajax.ajaxurl, obj);
        selectedData[agencyStateFauxKey] = data.data.StAbr;

        if (this.datafieldsdata[agencyStateFauxKey].selected) {
          this.searchData[agencyStateFauxKey] = { val: data.data.StAbr };
        }
        this.selectedData = selectedData;
        // GET STAFFING DATA
        this.setStaffingData();
        this.setStaffingData17();
        this.$nextTick(function () {
          this.getPeers();
        });
        this.$emit("setfeatured", nces_id);
        return;
      }
      if (this.preset == "districtprofile") {
        this.setStaffingData();
        this.setStaffingData17();
        bus.$emit("showStaticProfile", true);
        this.$emit("setfeatured", nces_id);
        let obj = new FormData();
        obj.append("action", "slide_get_search_data");
        let distProfileDatafields = [1, 5, 16, 20];
        let data_field_ids = JSON.stringify(distProfileDatafields);
        let params =
          '{"filters":{"nces_id":["' +
          nces_id +
          '"],"data_field_id":' +
          data_field_ids +
          '},"fields":{}}';
        obj.append("params", params);
        let data = await axios.post(axios_ajax.ajaxurl, obj);
        bus.$emit("setStaticProfileData", data.data);
        this.peerSlidersLoaded = true;

        let obj2 = new FormData();
        obj2.append("action", "slide_get_search_data");
        let librarian_field_id = "20";

        let params2 =
          '{"filters":{"nces_id":["' +
          nces_id +
          '"],"data_field_id":["20"],"staffing_years":["2017-18", "2018-19", "2019-20", "2020-21", "2021-22", "2022-23", "2023-24"]},"fields":{}}';
        obj2.append("params", params2);
        let data2 = await axios.post(axios_ajax.ajaxurl, obj2);
        bus.$emit("setStaticProfileLibrarianData", data2.data);

        return;
      }
    },
    async setStaffingData() {
      let staffingaction = "slide_get_district_staffing_history";
      obj = new FormData();
      obj.append("action", staffingaction);
      obj.append("nces_id", this.activeDistrict);
      perfObj = {
        method: "post",
        url: axios_ajax.ajaxurl,
        obj: obj,
        action: staffingaction
      };
      data = await slidePerf(perfObj);
      let newdata = data.data;
      const parseTime = d3.timeParse("%Y-%m-%d");
      for (let i = 0; i < newdata.length; i++) {
        for (let j = 0; j < newdata[i].Data.length; j++) {
          newdata[i].Data[j].value = +newdata[i].Data[j].value;
          newdata[i].Data[j].date = parseTime(newdata[i].Data[j].date);
        }
      }

      // FORCE LIBRARIANS TO BE FIRST

      let first = "Librarian FTEs";
      newdata.sort(function (x, y) {
        return x.Label == first ? -1 : y.Label == first ? 1 : 0;
      });

      bus.$emit("setStaffingData", newdata);
    },
    async setStaffingData17() {
      let staffingaction = "slide_get_district_staffing_history_17";
      obj = new FormData();
      obj.append("action", staffingaction);
      obj.append("nces_id", this.activeDistrict);
      perfObj = {
        method: "post",
        url: axios_ajax.ajaxurl,
        obj: obj,
        action: staffingaction
      };
      data = await slidePerf(perfObj);
      let newdata = data.data;
      const parseTime = d3.timeParse("%Y-%m-%d");
      for (let i = 0; i < newdata.length; i++) {
        for (let j = 0; j < newdata[i].Data.length; j++) {
          newdata[i].Data[j].value = +newdata[i].Data[j].value;
          newdata[i].Data[j].date = parseTime(newdata[i].Data[j].date);
        }
      }

      // FORCE LIBRARIANS TO BE FIRST

      let first = "Librarian FTEs";
      newdata.sort(function (x, y) {
        return x.Label == first ? -1 : y.Label == first ? 1 : 0;
      });
      console.log({ newdata });
      bus.$emit("setStaffingData17", newdata);
    },
    resetprofile() {
      this.$refs.slide_profile_districts.classList.remove("sliding");
      this.$refs.profile_demographics_wrapper.classList.remove("sliding");
      this.$refs.slide_profile_select.classList.remove("started");
      this.matchedDistricts = {};
      this.selectedData = {};
    },

    updaterange(field, start, end) {
      this.pendingChange = true;
      if (start == -999 && end == -999) {
        delete this.searchData[field.data_field_id];
        return;
      }
      this.searchData[field.data_field_id] = {};
      this.searchData[field.data_field_id].start = start;
      this.searchData[field.data_field_id].end = end;
    },
    updateboolean(field, val) {
      this.pendingChange = true;
      if (val == -999) {
        delete this.searchData[field.data_field_id];
        return;
      }
      this.searchData[field.data_field_id] = {};
      this.searchData[field.data_field_id].val = val;
    },
    updatecategory(field, vals) {
      this.pendingChange = true;
      if (vals == -999) {
        delete this.searchData[field.data_field_id];
        return;
      }
      this.searchData[field.data_field_id] = {};
      let valarray = [];
      for (const val in vals) {
        if (vals[val]) {
          valarray.push(val);
        }
      }
      this.searchData[field.data_field_id].val = valarray;
    },
    updatenone(field, val) {
      this.pendingChange = true;
      if (!val) {
        delete this.searchData[field.data_field_id];
        return;
      }
      this.searchData[field.data_field_id] = {};
      this.searchData[field.data_field_id].val = this.selectedData[field.data_field_id];
    },
    async getPeers() {
      this.isUpdating = true;
      let obj = new FormData();
      obj.append("action", "slide_get_districts");
      let params = { searchData: this.searchData };
      params = JSON.stringify(params);
      obj.append("params", params);
      let data = await axios.post(axios_ajax.ajaxurl, obj);

      this.matchedDistricts = data.data;

      this.$nextTick(async function () {
        if (!this.firstPeerSearchNumber && this.matchedDistricts.shared.length < 4) {
          document.querySelector("#pds-9999 input[type='checkbox']").click();
          this.firstPeerSearch = this.matchedDistricts.shared;
          this.firstPeerSearchNumber = this.matchedDistricts.shared.length;
          await this.getPeers();
        } else {
          this.isUpdating = false;
          this.pendingChange = false;
          this.$emit("setpeerdistricts", this.peerDistricts);
          bus.$emit("peersLoaded");
          this.$nextTick(async function () {
            bus.$emit("tutorialListener", "singledistrictloaded");
          });
        }
      });
    },

    removePeer(id) {
      let index = this.matchedDistricts.shared.indexOf(id);
      if (index > -1) {
        this.matchedDistricts.shared.splice(index, 1);
      }
      bus.$emit("removePeer", id);
      bus.$emit("toast", { text: "Peer Removed" });
    },
    updatesearch(type, values) {
      this.$emit("updatesearch", type, values);
    },
    submitAlternateView() {
      document.getElementById("geographyButton").click();
      bus.$emit("tutorialListener", "profilesubmitted");
    },
    show(field) {
      if (!this.selectedData[field]) {
        return false;
      }
      return true;
    },
    // functions for child items that other parents need
    isloading() {},
    isloaded() {},
    fielddataloaded() {},
    districtdataloaded() {}
  }
});
